import React from 'react';
import { useRecoilValue } from 'recoil';
import { withConfirmParams } from '../../../state/General/withConfirm';
import { ConfirmDialog } from './ConfirmDialog';

export const AppConfirmDialog: React.FC<React.PropsWithChildren<unknown>> = () => {
  const confirmParams = useRecoilValue(withConfirmParams);
  return <ConfirmDialog {...confirmParams}>{confirmParams.children}</ConfirmDialog>;
};
